import React, { useState, useEffect } from 'react'
import { Container, Stack, Typography, Button } from '@mui/material'
import ZoneInformation from './ZoneInformation'
import ApplicationCard from '../components/ApplicationCard'
import axios from '../services/axiosInstance'
import { useParams, useNavigate } from 'react-router'
import Grid from '@mui/material/Grid'

const DesignationSelection = () => {
  const [postsLoading, setPostsLoading] = useState(true)
  const [posts, setPosts] = useState([])

  const navigate = useNavigate()
  const { zone } = useParams()
  const selectedZoneName = zone ? zone.charAt(0).toUpperCase() + zone.slice(1) : ''

  useEffect(() => {
    handleChange(zone ? zone.charAt(0).toUpperCase() + zone.slice(1) : '')
  }, [zone])

  const handleChange = async (value) => {
    try {
      setPostsLoading(true)
      //   setZone(value)
      const response = await axios.get(`/application/get-all-zonal-post?zoneName=${value}`)
      setPosts(response.data.data.results)
    } catch (error) {
      console.error('Error fetching posts for zone:', error)
      //   setZone('')
    } finally {
      setPostsLoading(false)
    }
  }

  const locationData = JSON.parse(window.localStorage.getItem('locationData')) || []
  const zonesList = locationData.zones.map((zone) => zone.key)
  if (zonesList.includes(zone) === false) {
    return (
      <Container maxWidth='lg' sx={{ my: 2 }}>
        <Grid sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
          <Typography
            variant='h6' color='text.secondary'
            sx={{ textAlign: 'center', m: 2 }}
          >
            Invalid Zone Selected
          </Typography>
          <Button sx={{ }} variant='contained' onClick={() => navigate('/')}>Selected a Valid Zone</Button>
        </Grid>
      </Container>
    )
  }

  return (
    <Container maxWidth='lg' sx={{ my: 2 }}>
      {
        <>
          <ZoneInformation selectedZone={selectedZoneName} />
          <Typography
            sx={{ mt: 5, fontSize: '28px' }}
          >
            Select Designation
          </Typography>
          <Stack
            spacing={{ xs: 3, sm: 2, md: 4 }}
            direction={{ xs: 'column', sm: 'row' }}
            sx={{ mt: 1, mb: 5 }}
          >

            {postsLoading
              ? (
                <Typography
                  variant='h6'
                  color='text.secondary'
                  sx={{ mt: 5, textAlign: 'center' }}
                >
                  Loading posts...
                </Typography>
                )
              : posts.map((post, index) => {
                return (
                  <ApplicationCard
                    key={post.designation}
                    post={post.designation}
                    representativesCount={post.required}
                    appliedCount={post.appliedCount}
                    onApply={() =>
                      navigate(`/apply/${zone}/${post.designation}`)}
                        // handleOnClickApply(post.designation)

                  />
                )
              })}
          </Stack>
        </>
          }
    </Container>
  )
}

export default DesignationSelection
